// Module
var code = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12 8.638c.35 0 .7.15.95.4l4.75 4.8c.35.35.35.9 0 1.25s-.9.35-1.25 0l-4.35-4.35a.152.152 0 00-.2 0l-4.35 4.35c-.35.35-.9.35-1.25 0a.875.875 0 010-1.25l4.75-4.75c.25-.3.6-.45.95-.45z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>";
// Exports
module.exports = code;